import { FederationEvent } from '../types/types';

/**
 * Publishes whether Intercom is in **messenger** mode (company has the full
 * Intercom Messenger product, not just notifications) for federated remotes
 * (e.g. aidi) to gate features that require opening the messenger widget.
 */
export function publishIntercomMessengerAvailability(available: boolean): void {
  if (typeof window === 'undefined') return;
  window.__FEDERATION_BRIDGE__?.communicationService?.publish(
    FederationEvent.INTERCOM_MESSENGER_AVAILABILITY_UPDATED,
    available
  );
}
